import { TextDisplayCell } from "../../../common/components/DataGrid";
import { generateTransformCell } from "../../helpers/CellGenerators";

export const TransformCell = ({ row }) => {
  return <TextDisplayCell value={generateTransformCell(row)} />;
};
